import React from 'react';
import * as ErrorMessage from '../../../constants/common/ErrorMessage';

/**
 * Header
 */
class Header extends React.Component {

  constructor(props) {
    super(props);
    this.handleOpenMenuClick = this.handleOpenMenuClick.bind(this);
  }

  handleOpenMenuClick() {
    $('#menu_page').show();
  }

  render() {
    let errorstyle = null;
    let comments;

    if (this.props.error != null) {
      errorstyle = {
        background: '#fc765d'
      };

      const getCode = this.props.error.message;

      const errormessage = ErrorMessage.ERROR_MESSAGE.filter((item) => {
        return (item.code == getCode);
      });

      comments = <p id="header_mobile_error">{errormessage[0].message}</p>;
    }

    let viewName = '';
    const pathName = location.pathname;
    if (pathName.indexOf('K007') !== -1) {
      viewName = 'ランキング';
    } else if (pathName.indexOf('K012') !== -1) {
      viewName = '導入後推移';
    } else if (pathName.indexOf('K013') !== -1) {
      viewName = '設定別';
    }
    viewName += '▾';

    if ($('#header_error_used_machine_price').is(':visible')) {
      $('#header_error_used_machine_price').hide();
      $('#header_wrap_mobile').css('background-color', 'var(--color-scheme-common-black)');
    }

    return (
      <header>
        {/* ---#headerWrap- */}
        <div id="header_wrap_mobile" className="clearfix header_wrap_mobile" style={errorstyle}>
          <a href="/" title="ホーム">
            <img src="/img/header_logo01_mobile.png" alt="VECTERA クラウドサービス" height={51} />
          </a>
          <div className="header_mobile_header" onClick={e => this.handleOpenMenuClick(e)}>
            <p className="header_mobile_title">{viewName}</p>
            <p id="header_error_used_machine_price">コピーできません</p>
            {comments}
          </div>
          <a href={PORTAL_URL} title="ポータル">
            <img src="/img/icon/fab_ポータルボタン_共通.svg" alt="Portal" height={51} />
          </a>
          <a href="#" title="ログアウト" onClick={() => this.props.comactions.logout()}>
            <img src="/img/icon/fab_ログアウトボタン_共通.svg" alt="Logout" height={51} />
          </a>

        </div>{/* ---//#headerWrap-*/}
      </header>
    );
  }
}


export default Header;
